module.exports = __webpack_public_path__ + "static/media/icon_list_normal.4f05c82a.svg";